var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"ProductDescription"}},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.productDescription)}})])}
var staticRenderFns = []

export { render, staticRenderFns }